module.exports = __webpack_public_path__ + "1_0_60/img/Big Ben 2.b8649a87.jpg";